import React from 'react';

export const CorrectCharacter = () => {
  return <span>&#10003;</span>;
};
